module.exports = __webpack_public_path__ + "static/media/toplife-logo-white.b0106a5c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/login/toplife-logo-white.svg
// module id = 811
// module chunks = 0